import { Sparkles } from "lucide-react";

import { cn } from "@/lib/utils";

const MAX_LABEL_LENGTH = 55;

interface SuggestionChipsProps {
  suggestions: readonly string[];
  isSelected: (value: string) => boolean;
  onSelect: (value: string) => void;
}

/**
 * Suggested-prompt chips. Every suggestion stays rendered; a clicked chip is
 * highlighted rather than removed, so the user can still pick the others.
 */
export function SuggestionChips({ suggestions, isSelected, onSelect }: SuggestionChipsProps) {
  return (
    <div className="mt-3 overflow-x-auto flex gap-1.5 pb-1 no-scrollbar">
      {suggestions.map((s) => {
        const selected = isSelected(s);
        return (
          <button
            key={s}
            type="button"
            aria-pressed={selected}
            onClick={() => onSelect(s)}
            className={cn(
              "inline-flex items-center gap-1 px-2 py-1 rounded-md text-[11px] whitespace-nowrap shrink-0 border cursor-pointer transition-colors",
              selected
                ? "bg-info/10 text-info border-info/40 hover:bg-info/15"
                : "bg-muted/60 text-muted-foreground border-border hover:bg-muted",
            )}
          >
            <Sparkles size={10} className={selected ? "text-info" : "text-muted-foreground"} />
            {s.length > MAX_LABEL_LENGTH ? s.slice(0, MAX_LABEL_LENGTH) + "..." : s}
          </button>
        );
      })}
    </div>
  );
}
